export const wcApiDataService = async (path: string, subQuery: string, locale: string | undefined) => {

  var queryString: any = "";
  var backendURL: any = process.env.NEXT_PUBLIC_LARAVEL_URL;

  if (locale === 'ca') {
    queryString = "region=ca";
  } else if (locale === 'nz') {
    queryString = "region=nz";
  } else if (locale === 'international') {
    queryString = "region=int";
  } else if (locale === 'au') {
    queryString = "region=au";
  }

  if (subQuery != "") {
    queryString = subQuery + "&" + queryString;
  } 
  //if env is not production 
  if (process.env.NEXT_PUBLIC_ENV !== 'production') {
    queryString = queryString +  '&clearCache';
  }
  //console.log('wcApiDataService fetch url', backendURL + "/wc/" + path + "?" + queryString);
  return await fetch(backendURL + "/wc/" + path + "?" + queryString, { cache: 'no-store' }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    return null;
  })
    .catch((error) => {
      console.log(error)
      return null;
    });
};


